import { useEffect } from "react"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"

import GoogleSignOn from "../../Shared/GoogleSignOn/GoogleSignOn"
import CognitoSignOn from "../../Shared/CognitoSignOn/CognitoSignOn"

import { useHistory } from "react-router-dom"
import Inbox from "../../Shared/Inbox/Inbox"

function Home(props) {
  const { setAppBarTitle, user, backgroundProcessor, appMode } = props
  const history = useHistory()

  useEffect(() => {
    if (user) {
      setAppBarTitle("Inbox")
    } else {
      setAppBarTitle("Login")
    }
  })

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ paddingBottom: "1rem", backgroundColor: "lightgrey" }}
    >
      <Grid
        container
        item
        direction="column"
        alignItems="center"
        style={{ paddingBottom: "1rem", paddingTop: "2rem" }}
      >
        <Grid item>
          <h1>BIDs User Portal</h1>
        </Grid>
      </Grid>

      {user && (
        <Grid container item direction="column" style={{ width: "90vw" }}>
          <Paper elevation={3} className="home-container">
            <Grid container item direction="column">
              <Grid
                container
                item
                direction="column"
                alignItems="flex-start"
                style={{ paddingBottom: "1rem", paddingLeft: "1rem" }}
              >
                <Grid item>
                  <Inbox {...props} appMode={appMode} />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      )}

      {!user && (
        <Grid container item direction="column" style={{ maxWidth: "640px" }}>
          <Paper elevation={3} className="MuiPaper-core">
            <Grid container item direction="column">
              <Grid
                container
                item
                direction="column"
                alignItems="center"
                style={{ paddingBottom: "2rem" }}
              >
                <Grid item>
                  <GoogleSignOn {...props} disableResize={true} dark={false} />
                </Grid>
              </Grid>

              <Grid
                container
                item
                direction="column"
                alignItems="center"
                style={{ paddingBottom: "1rem" }}
              >
                <Grid item>
                  <p>
                    If you are an NWEC or HOLBA officer, please login using your provided username and password below
                  </p>
                </Grid>
              </Grid>

              <Grid item style={{ flexGrow: 1 }}>
                <CognitoSignOn {...props} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default Home
